import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import EntityFilterOptions from './EntFilterOpts';
import { ModuleContentTooltip } from '../../components/Common/MUIStyledComponents';
import { CustomLabel, CustomSwitch } from '../../components/Common/MUIStyledComponents';
import CommodityFilterOptions from './ComFilterOpts';
import DatahubAPI from 'api/DatahubAPI';
import { formatDate } from 'utils/dateFormater';
interface IFilterOptions {
  setFilterMode: any;
  submit: any;
  setSubmit: any;
  entityState: any;
  setEntityState: any;
  commodityState: any;
  setCommodityState: any;
  appliedFilter: any;
  handleClear: any;
  updateFilter?: any;
  setOpenDate: any;
  result?: boolean;
  openTab?: string;
  handleSaveChanges?: any;
  handleSaveAndResubmit?: any;
  screenLoading?: boolean;
}

const ModalLayout: React.FC<IFilterOptions> = ({ entityState, setEntityState, commodityState, setCommodityState, setFilterMode,
  submit,
  setSubmit,
  appliedFilter,
  handleClear,
  updateFilter,
  setOpenDate,
  result,
  openTab,
  handleSaveChanges,
  handleSaveAndResubmit,
  screenLoading,

}) => {
  const [ tab, setTab ] = useState(openTab ? openTab : 'Entities');

  // ENTITY FILTERS
  const [ lensOpts, setLensOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: [] });
  const [ countryOpts, setCountryOpts ] = useState<{
        isLoading: boolean;
        data: any;
      }>({ isLoading: true, data: [] });
  const [ agencyOpts, setAgencyOpts ] = useState<{
        isLoading: boolean;
        data: any;
      }>({ isLoading: true, data: [] });
  const [ listOpts, setListOpts ] = useState<{
        isLoading: boolean;
        data: any;
      }>({ isLoading: true, data: [] });

  const [ countOpts, setCountOpts ] = useState([]);
  const [ agOpts, setAgOpts ] = useState([]);

  // DATA FILTERS
  const [ comLensOpts, setComLensOpts ] = useState<{
        isLoading: boolean;
        data: any;
      }>({ isLoading: true, data: [] });
  const [ comCountryOpts, setComCountryOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: [] });
  const [ comAgencyOpts, setComAgencyOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: [] });
  const [ comListOpts, setComListOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: [] });


  const initialAPICall = async() => {
    // ENTITY
    const aggQuery: any = {
      agg: true,
    };
    const aggRes = await DatahubAPI.entitySearch(aggQuery);
    if (aggRes?.success) {
      setLensOpts({ isLoading: false, data: [ ...aggRes.result.result.body.aggregations.entityAggs.buckets ] });
      const countryBuckets: any = [];
      aggRes.result?.result?.body?.aggregations?.entityAggs?.buckets.map((bucket: any) => {
        countryBuckets.push(bucket.countryAgg.buckets);
      });

      setCountryOpts({ isLoading: false, data: countryBuckets.flat() });
      const agencyBuckets: any = [];
      aggRes.result?.result?.body?.aggregations?.entityAggs?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          agencyBuckets.push(secondBucket.agencyAgg.buckets);
        });
      });

      setAgencyOpts({ isLoading: false, data: agencyBuckets.flat() });
      const listBuckets: any = [];
      aggRes.result?.result?.body?.aggregations?.entityAggs?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          secondBucket.agencyAgg.buckets.map((thirdBucket: any) => {
            listBuckets.push(thirdBucket.listNameAgg.buckets);
          });
        });
      });

      setListOpts({ isLoading: false, data: listBuckets.flat() });
    }
    // COMMODITY
    const filtersAggQuery: any = {
      indices: [ 'bite_app_commodities_*' ],
      agg: true,
    };

    const filtersAggRes = await DatahubAPI.commoditySearch(filtersAggQuery);
    if (filtersAggRes?.success) {
      setComLensOpts({ isLoading: false, data: [ ...filtersAggRes?.result.result.body.aggregations.listAgg.buckets ] });
      const countryBuckets: any = [];
      filtersAggRes?.result?.result?.body?.aggregations?.listAgg?.buckets.map((bucket: any) => {
        countryBuckets.push(bucket.countryAgg.buckets);
      });

      setComCountryOpts({ isLoading: false, data: countryBuckets.flat() });
      const agencyBuckets: any = [];
      filtersAggRes.result?.result?.body?.aggregations?.listAgg?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          agencyBuckets.push(secondBucket.agencyAgg.buckets);
        });
      });

      setComAgencyOpts({ isLoading: false, data: agencyBuckets.flat() });
      const listBuckets: any = [];
      filtersAggRes.result?.result?.body?.aggregations?.listAgg?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          secondBucket.agencyAgg.buckets.map((thirdBucket: any) => {
            listBuckets.push(thirdBucket.listNameAgg.buckets);
          });
        });
      });

      setComListOpts({ isLoading: false, data: listBuckets.flat() });
    }
  };

  // ENTITY CHANGES
  // HNDLE LENS CHANGE
  const handleLensChange = async() => {
    setCountryOpts({ ...countryOpts, isLoading: true });
    setAgencyOpts({ ...agencyOpts, isLoading: true });
    setListOpts({ ...listOpts, isLoading: true });
    const query: any = {
      updateDay: entityState.dateArr,
      lens: entityState.lenses,
      agg: true,
    };
    const res = await DatahubAPI.entitySearch(query);
    if (res?.success && entityState.lenses.length) {
      const addedBuckets: any = [];
      res?.result?.result?.body?.aggregations?.entityAggs?.buckets.map((bucket: any) => {
        addedBuckets.push(bucket.countryAgg.buckets);
      });
      const selections = addedBuckets.flat().map((obj: any) => {
        return obj.key;
      });
      setEntityState({
        ...entityState,
        countries: selections
      });
      setCountOpts(selections);
    } else if (entityState.lenses.length === 0) {
      setEntityState({
        ...entityState,
        countries: [],
        agencies: [],
        lists: [],
      });
    }
    setSubmit({
      trigger: !submit.trigger,
      reason: 'Listing Country',
      location: 'Entity'
    });
  };


  // HANDLE COUNTRY CHANGE
  const handleCountryChange = async() => {
    setAgencyOpts({ ...agencyOpts, isLoading: true });
    setListOpts({ ...listOpts, isLoading: true });
    const query: any = {
      lens: entityState.lenses,
      listCountry: entityState.countries,
      updateDay: entityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.entitySearch(query);
    if (res?.success && entityState.countries.length > 0) {
      const addedBuckets: any = [];
      res?.result?.result?.body?.aggregations?.entityAggs?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          addedBuckets.push(secondBucket.agencyAgg.buckets);
        });
      });
      const selections = addedBuckets.flat().map((obj: any) => {
        return obj.key;
      });
      setEntityState({
        ...entityState,
        agencies: selections
      });
      setAgOpts(selections);
    } else if (entityState.countries.length === 0) {
      setEntityState({
        ...entityState,
        agencies: [],
        lists: [],
      });
    }
    setSubmit({
      trigger: !submit.trigger,
      reason: 'Agency',
      location: 'Entity'
    });
    setCountryOpts({ ...countryOpts, isLoading: false });
  };

  // HANDLE AGENCY CHANGE
  const handleAgencyChange = async() => {
    setListOpts({ ...listOpts, isLoading: true });
    const query: any = {
      lens: entityState.lenses,
      agency: entityState.agencies,
      updateDay: entityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.entitySearch(query);
    if (res?.success && entityState.agencies.length > 0) {
      const addedBuckets: any = [];
      res?.result?.result?.body?.aggregations?.entityAggs?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          secondBucket.agencyAgg.buckets.map((thirdBucket: any) => {
            addedBuckets.push(thirdBucket.listNameAgg.buckets);
          });
        });
      });
      const selections = addedBuckets.flat().map((obj: any) => {
        return obj.key;
      });
      setEntityState({
        ...entityState,
        lists: selections
      });
    } else if (entityState.agencies.length === 0) {
      setEntityState({
        ...entityState,
        lists: [],
      });
    }
    setSubmit({
      trigger: !submit.trigger,
      reason: 'List',
      location: 'Entity'
    });
    setAgencyOpts({ ...agencyOpts, isLoading: false });
  };

  // HANDLE LIST CHANGE
  const handleListChange = async() => {
    const query: any = {
      lens: entityState.lenses,
      listName: entityState.lists,
      updateDay: entityState.dateArr,
      agg: true,
    };
    await DatahubAPI.entitySearch(query);

    setListOpts({ ...listOpts, isLoading: false });
  };
  // END ENTITY CHANGES

  // COMMODITY CHANGES
  // HNDLE LENS CHANGE
  const handleComLensChange = async() => {
    setCountryOpts({ ...countryOpts, isLoading: true });
    setAgencyOpts({ ...agencyOpts, isLoading: true });
    setListOpts({ ...listOpts, isLoading: true });
    const query: any = {
      indices: [ 'bite_app_commodities_*' ],
      lens: commodityState.comLenses,
      updateDay: commodityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.commoditySearch(query);
    if (res?.success && commodityState.comLenses.length > 0) {
      const addedBuckets: any = [];
      res?.result?.result?.body?.aggregations?.listAgg?.buckets.map((bucket: any) => {
        addedBuckets.push(bucket.countryAgg.buckets);
      });
      const selections = addedBuckets.flat().map((obj: any) => {
        return obj.key;
      });

      setCommodityState({
        ...commodityState,
        countries: selections
      });
      setCountOpts(selections);
    } else if (commodityState.comLenses.length === 0) {
      setCountOpts([]);
      setCommodityState({
        ...commodityState,
        countries: [],
        agencies: [],
        lists: [],
      });
    }
    setSubmit({
      trigger: !submit.trigger,
      reason: 'Country Regulator',
      location: 'Commodity'
    });
  };


  // HANDLE COUNTRY CHANGE
  const handleComCountryChange = async() => {
    setAgencyOpts({ ...agencyOpts, isLoading: true });
    setListOpts({ ...listOpts, isLoading: true });
    const query: any = {
      indices: [ 'bite_app_commodities_*' ],
      lens: commodityState.comLenses,
      listCountry: commodityState.countries,
      updateDay: commodityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.commoditySearch(query);
    if (res?.success && commodityState.countries.length > 0) {
      const addedBuckets: any = [];
      res?.result?.result?.body?.aggregations?.listAgg?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          addedBuckets.push(secondBucket.agencyAgg.buckets);
        });
      });
      const selections = addedBuckets.flat().map((obj: any) => {
        return obj.key;
      });
      setCommodityState({
        ...commodityState,
        agencies: selections
      });
      setAgOpts(selections);
    } else if (commodityState.countries.length === 0) {
      setCommodityState({
        ...commodityState,
        agencies: [],
        lists: [],
      });
      setAgOpts([]);
    }
    setSubmit({
      trigger: !submit.trigger,
      reason: 'Agency',
      location: 'Commodity'
    });
    setCountryOpts({ ...countryOpts, isLoading: false });
  };

  // HANDLE AGENCY CHANGE
  const handleComAgencyChange = async() => {
    setListOpts({ ...listOpts, isLoading: true });
    const query: any = {
      indices: [ 'bite_app_commodities_*' ],
      lens: commodityState.comLenses,
      agency: commodityState.agencies,
      updateDay: commodityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.commoditySearch(query);
    if (res?.success && commodityState.agencies.length > 0) {
      const addedBuckets: any = [];
      res?.result?.result?.body?.aggregations?.listAgg?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          secondBucket.agencyAgg.buckets.map((thirdBucket: any) => {
            addedBuckets.push(thirdBucket.listNameAgg.buckets);
          });
        });
      });
      const selections = addedBuckets.flat().map((obj: any) => {
        return obj.key;
      });
      setCommodityState({
        ...commodityState,
        lists: selections
      });
    } else if (commodityState.agencies.length === 0) {
      setCommodityState({
        ...commodityState,
        lists: [],
      });
    }
    setSubmit({
      trigger: !submit.trigger,
      reason: 'List',
      location: 'Commodity'
    });
    setAgencyOpts({ ...agencyOpts, isLoading: false });
  };

  // HANDLE LIST CHANGE
  const handleComListChange = async() => {
    const query: any = {
      indices: [ 'bite_app_commodities_*' ],
      lens: commodityState.comLenses,
      listName: commodityState.lists,
      updateDay: commodityState.dateArr,
      agg: true,
    };
    await DatahubAPI.commoditySearch(query);
    setListOpts({ ...listOpts, isLoading: false });
  };

  useEffect(() => {
    switch (submit.location) {
    case 'Entity':
      switch (submit.reason) {
      case 'Lens':
        handleLensChange();
        break;
      case 'Listing Country':
        handleCountryChange();
        break;
      case 'Agency':
        handleAgencyChange();
        break;
      case 'List':
        handleListChange();
        break;
      default:
        initialAPICall();
      }
      break;
    default:
      switch (submit.reason) {
      case 'Lens':
        handleComLensChange();
        break;
      case 'Country Regulator':
        handleComCountryChange();
        break;
      case 'Agency':
        handleComAgencyChange();
        break;
      case 'List':
        handleComListChange();
        break;
      default:
        initialAPICall();
      }
    }
  }, [ submit ]);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEntityState({ ...entityState, fuzzy: event.target.checked });
    setCommodityState({ ...commodityState, fuzzy: event.target.checked });
    setSubmit({ reason: 'apply', trigger: !submit.trigger, location: 'Entity' });
  };

  const handleApply = () => {
    setSubmit({
      trigger: !submit.trigger,
      reason: 'apply',
      location: 'Entity'
    });
    setFilterMode(false);
  };

  const handleTabSwitch = (newTab: string) => {
    switch (newTab) {
    case 'Entities':
      setTab('Entities');
      window.sessionStorage.setItem('tab', 'Entities');
      break;
    case 'Commodities':
      setTab('Commodities');
      window.sessionStorage.setItem('tab', 'Commodities');
      break;
    case 'Saved':
      setTab('Saved');
      window.sessionStorage.setItem('tab', 'Saved');
      break;
    default:
      setTab('Entities');
    }
  };

  const handleClearDate = () => {
    setOpenDate(false);
    setEntityState({ ...entityState, date: null, dateRange: [] });
    setCommodityState({ ...commodityState, date: null, dateRange: [] });
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  useEffect(() => {}, [ entityState ]);

  return (
    <>
      {screenLoading ?
        <div className='filter-options-container-loading'>
          <div className='loading-spinner-cont-modal'>
            <svg className='spinner' xmlns='http://www.w3.org/2000/svg' width='32' height='33' viewBox='0 0 32 33' fill='none'>
              <g clipPath='url(#clip0_4006_13811)'>
                <circle cx='16' cy='3.75' r='3' fill='white' fillOpacity='0.1'/>
                <circle opacity='0.45' cx='16' cy='29.75' r='3' fill='white' fillOpacity='0.65'/>
                <circle cx='3' cy='16.75' r='3' fill='white' fillOpacity='0.85'/>
                <circle cx='29' cy='16.75' r='3' fill='white' fillOpacity='0.35'/>
                <circle cx='26' cy='7.75' r='3' fill='white' fillOpacity='0.25'/>
                <circle cx='26' cy='25.75' r='3' fill='white' fillOpacity='0.45'/>
                <circle cx='6' cy='25.75' r='3' fill='white' fillOpacity='0.75'/>
                <circle cx='6' cy='7.75' r='3' fill='white'/>
              </g>
              <defs>
                <clipPath id='clip0_4006_13811'>
                  <rect width='32' height='32' fill='white' transform='translate(0 0.75)'/>
                </clipPath>
              </defs>
            </svg>
            <p>Screening in Progress...</p>
          </div>
        </div> :
        <div className='filter-options-container'>
          <div className='filter-options-header'>
            <div className='filter-options-header-cont'>
              <div className='filter-options-header-content'>
                <div className='filter-options-header-icon'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                    <path d='M6 12H18M3 6H21M9 18H15' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                </div>
                <div className='filter-options-header-text-group-new'>
                  <div className='filter-options-header-text-primary'>
              Screening Parameters
                  </div>
                </div>


              </div>
              <div className='filter-options-header-content'>

                <div className='filter-select-no-box-new'>
                  <div className='filter-select-tooltip'>
                    <div className='filter-select-box-text'>Entity Resolution?</div>
                    <ModuleContentTooltip
                      title={
                        <p className='module-header-tooltip-text'>
                                Entity Resolution is the ability to link records that have the same data in real life but may have a different spelling or formatting between the data sets being compared.
                        </p>
                      }
                      placement='top'
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            'display': 'flex',
                            'padding': 'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                            'flexDirection': 'column',
                            'alignItems': 'flex-start',
                            'alignSelf': 'stretch',
                            'borderRadius': 'var(--radius-md, 8px)',
                            'background': 'var(--Background-200, #202227)',
                            'maxWidth': '400px',
                            '& .MuiTooltip-arrow': {
                              color: 'var(--Background-200, #202227)'
                            }
                          },
                        },
                      }}
                    >
                      <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                        <path d='M9 8.25C8.80109 8.25 8.61033 8.32902 8.46967 8.46967C8.32902 8.61032 8.25 8.80109 8.25 9V12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61033 12.671 8.80109 12.75 9 12.75C9.19892 12.75 9.38968 12.671 9.53033 12.5303C9.67099 12.3897 9.75 12.1989 9.75 12V9C9.75 8.80109 9.67099 8.61032 9.53033 8.46967C9.38968 8.32902 9.19892 8.25 9 8.25ZM9.285 5.31C9.10241 5.23499 8.8976 5.23499 8.715 5.31C8.62294 5.3457 8.53883 5.39922 8.4675 5.4675C8.40126 5.5404 8.34799 5.62411 8.31 5.715C8.26802 5.80401 8.24747 5.90162 8.25 6C8.24943 6.0987 8.26835 6.19655 8.30568 6.28793C8.343 6.37931 8.39799 6.46242 8.4675 6.5325C8.5404 6.59875 8.62412 6.65202 8.715 6.69C8.82863 6.73668 8.95198 6.75474 9.07421 6.74258C9.19645 6.73043 9.31383 6.68844 9.41604 6.6203C9.51825 6.55216 9.60215 6.45996 9.66039 6.3518C9.71862 6.24364 9.74939 6.12284 9.75 6C9.74724 5.80142 9.66955 5.61123 9.5325 5.4675C9.46118 5.39922 9.37707 5.3457 9.285 5.31ZM9 1.5C7.51664 1.5 6.0666 1.93987 4.83323 2.76398C3.59986 3.58809 2.63856 4.75943 2.07091 6.12987C1.50325 7.50032 1.35472 9.00832 1.64411 10.4632C1.9335 11.918 2.64781 13.2544 3.6967 14.3033C4.7456 15.3522 6.08197 16.0665 7.53683 16.3559C8.99168 16.6453 10.4997 16.4968 11.8701 15.9291C13.2406 15.3614 14.4119 14.4001 15.236 13.1668C16.0601 11.9334 16.5 10.4834 16.5 9C16.5 8.01509 16.306 7.03982 15.9291 6.12987C15.5522 5.21993 14.9997 4.39314 14.3033 3.6967C13.6069 3.00026 12.7801 2.44781 11.8701 2.0709C10.9602 1.69399 9.98492 1.5 9 1.5ZM9 15C7.81332 15 6.65328 14.6481 5.66658 13.9888C4.67989 13.3295 3.91085 12.3925 3.45673 11.2961C3.0026 10.1997 2.88378 8.99334 3.11529 7.82946C3.3468 6.66557 3.91825 5.59647 4.75736 4.75736C5.59648 3.91824 6.66558 3.3468 7.82946 3.11529C8.99335 2.88378 10.1997 3.0026 11.2961 3.45672C12.3925 3.91085 13.3295 4.67988 13.9888 5.66658C14.6481 6.65327 15 7.81331 15 9C15 10.5913 14.3679 12.1174 13.2426 13.2426C12.1174 14.3679 10.5913 15 9 15Z' fill='#F5FAFF'/>
                      </svg>
                    </ModuleContentTooltip>
                  </div>
                  <CustomLabel
                    control={<CustomSwitch checked={entityState.fuzzy} onChange={handleSwitchChange} name='fuzzy' />}
                    label={entityState.fuzzy ? 'Yes' : 'No'}
                  />
                </div>
                <div className='filter-select-box-new' onClick={() => setOpenDate(true)}>
                  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                    <path d='M15.75 7.5H2.25M12 1.5V4.5M6 1.5V4.5M5.85 16.5H12.15C13.4101 16.5 14.0402 16.5 14.5215 16.2548C14.9448 16.039 15.289 15.6948 15.5048 15.2715C15.75 14.7902 15.75 14.1601 15.75 12.9V6.6C15.75 5.33988 15.75 4.70982 15.5048 4.22852C15.289 3.80516 14.9448 3.46095 14.5215 3.24524C14.0402 3 13.4101 3 12.15 3H5.85C4.58988 3 3.95982 3 3.47852 3.24524C3.05516 3.46095 2.71095 3.80516 2.49524 4.22852C2.25 4.70982 2.25 5.33988 2.25 6.6V12.9C2.25 14.1601 2.25 14.7902 2.49524 15.2715C2.71095 15.6948 3.05516 16.039 3.47852 16.2548C3.95982 16.5 4.58988 16.5 5.85 16.5Z' stroke='#BDBEC1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                  {entityState.dateRange.length > 0 && entityState.dateRange[0] !== null && entityState.dateRange[1] !== null ? (
                    <div className='filter-select-box-text'>{formatDate(entityState.dateRange[0])} - {formatDate(entityState.dateRange[1])}</div>
                  ) : (
                    <div className='filter-select-box-text'>Date</div>
                  )}

                  {entityState.dateRange.length > 0 && entityState.dateRange[0] !== null && entityState.dateRange[1] !== null ? (
                    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' style={{ zIndex: 10 }} onClick={(event) => {
                      event.stopPropagation();
                      handleClearDate();
                    }}>
                      <path d='M15 5L5 15M5 5L15 15' stroke='#CECFD2' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  ) : (
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                      <path d='M9.17019 6.99981C8.98394 7.18717 8.87939 7.44062 8.87939 7.70481C8.87939 7.96899 8.98394 8.22244 9.17019 8.40981L12.7102 11.9998L9.17019 15.5398C8.98394 15.7272 8.87939 15.9806 8.87939 16.2448C8.87939 16.509 8.98394 16.7624 9.17019 16.9498C9.26315 17.0435 9.37375 17.1179 9.49561 17.1687C9.61747 17.2195 9.74818 17.2456 9.88019 17.2456C10.0122 17.2456 10.1429 17.2195 10.2648 17.1687C10.3866 17.1179 10.4972 17.0435 10.5902 16.9498L14.8302 12.7098C14.9239 12.6168 14.9983 12.5062 15.0491 12.3844C15.0998 12.2625 15.126 12.1318 15.126 11.9998C15.126 11.8678 15.0998 11.7371 15.0491 11.6152C14.9983 11.4934 14.9239 11.3828 14.8302 11.2898L10.5902 6.99981C10.4972 6.90608 10.3866 6.83169 10.2648 6.78092C10.1429 6.73015 10.0122 6.70401 9.88019 6.70401C9.74818 6.70401 9.61747 6.73015 9.49561 6.78092C9.37375 6.83169 9.26315 6.90608 9.17019 6.99981Z' fill='#BDBEC1'/>
                    </svg>
                  )}
                </div>
              </div>

            </div>

            <div className='filter-options-header-close' onClick={() => {
              setFilterMode(false);
              handleApply();
            }
            }>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M18 6L6 18M6 6L18 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
          </div>
          <div className='filter-modal-tabs-container'>
            <div className='screening-tabs-inner'>
              <div
                className={`screening-tab-btn${tab === 'Entities' ? '-selected' : ''
                }`}
                onClick={() => handleTabSwitch('Entities')}
              >
                <div
                  className={`screening-tab-btn-text${tab === 'Entities' ? '-selected' : ''
                  }`}
                >
              People & Companies
                </div>
              </div>
              <div
                className={`screening-tab-btn${tab === 'Commodities' ? '-selected' : ''
                }`}
                onClick={() => handleTabSwitch('Commodities')}
              >
                <div
                  className={`screening-tab-btn-text${tab === 'Commodities' ? '-selected' : ''
                  }`}
                >
              Products
                </div>
              </div>
            </div>
          </div>
          {tab === 'Entities' && (
            <EntityFilterOptions
              lensOpts={lensOpts}
              submit={submit}
              setSubmit={setSubmit}
              countryOpts={countryOpts}
              agencyOpts={agencyOpts}
              listOpts={listOpts}
              entityState={entityState}
              setEntityState={setEntityState}
              countOpts={countOpts}
              agOpts={agOpts}
            />
          )}
          {tab === 'Commodities' && (
            <CommodityFilterOptions
              commodityState={commodityState}
              setCommodityState={setCommodityState}
              setFilterMode={setFilterMode}
              lensOpts={comLensOpts}
              countryOpts={comCountryOpts}
              agencyOpts={comAgencyOpts}
              listOpts={comListOpts}
              setSubmit={setSubmit}
              submit={submit}
              countOpts={countOpts}
              agOpts={agOpts}
            />
          )}
          <div className='filter-options-btns-container'>
            <div className='filter-options-btns-spacer'>
              {Object.keys(appliedFilter).length > 1 && <Button sx={{ color: '#4895EF', marginLeft: '20px' }} onClick={() => {
                updateFilter();
              }}>Update</Button>}
              <Button
                disabled={countryOpts.isLoading || agencyOpts.isLoading || listOpts.isLoading || comCountryOpts.isLoading || comAgencyOpts.isLoading || comListOpts.isLoading}
                onClick={() => {
                  handleClear();
                }}
                sx={{ color: '#EFF1F6', textTransform: 'capitalize' }}>Reset</Button>
              <Button
                disabled={countryOpts.isLoading || agencyOpts.isLoading || listOpts.isLoading || comCountryOpts.isLoading || comAgencyOpts.isLoading || comListOpts.isLoading}
                onClick={() => {
                  handleSaveChanges();
                }}
                sx={{ color: '#BDBEC1', border: '1px solid #2E3036', textTransform: 'capitalize' }}>Save Changes</Button>
              {result ? (
                <Button
                  sx={{ color: '#EFF1F6', textTransform: 'capitalize', background: '#4895EF' }}
                  onClick={handleSaveAndResubmit} disabled={countryOpts.isLoading || agencyOpts.isLoading || listOpts.isLoading || comCountryOpts.isLoading || comAgencyOpts.isLoading || comListOpts.isLoading || !handleSaveAndResubmit}
                >Save & Resubmit
                </Button>
              ) : (
                <Button
                  sx={{ color: '#EFF1F6', textTransform: 'capitalize', background: '#4895EF' }}
                  onClick={handleApply} disabled={countryOpts.isLoading || agencyOpts.isLoading || listOpts.isLoading || comCountryOpts.isLoading || comAgencyOpts.isLoading || comListOpts.isLoading}
                >Apply
                </Button>

              )}
            </div>
          </div>
        </div>}
    </>
  );
};

export default ModalLayout;
